var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLinkArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.54838 0.5C9.10066 0.5 9.54838 0.947715 9.54838 1.5C9.54838 2.05228 9.10066 2.5 8.54838 2.5H5.5C3.84315 2.5 2.5 3.84315 2.5 5.5V14.5C2.5 16.1569 3.84315 17.5 5.5 17.5H14.5C16.1569 17.5 17.5 16.1569 17.5 14.5V11.5C17.5 10.9477 17.9477 10.5 18.5 10.5C19.0523 10.5 19.5 10.9477 19.5 11.5V14.5C19.5 17.2614 17.2614 19.5 14.5 19.5H5.5C2.73858 19.5 0.5 17.2614 0.5 14.5V5.5C0.5 2.73858 2.73858 0.5 5.5 0.5H8.54838ZM19.2265 0.812803C18.9741 0.54599 18.6096 0.448835 18.2758 0.5253C18.1864 0.508687 18.0942 0.500002 18 0.500002H13.5C12.9477 0.500002 12.5 0.947718 12.5 1.5C12.5 2.05229 12.9477 2.5 13.5 2.5H15.9877L13.1878 5.14853L10.8753 7.33603C10.4741 7.71556 10.4565 8.34848 10.836 8.7497C11.2156 9.15092 11.8485 9.1685 12.2497 8.78897L14.5622 6.60147L17.5 3.82247V6.5C17.5 7.05229 17.9477 7.5 18.5 7.5C19.0523 7.5 19.5 7.05229 19.5 6.5V2C19.5 1.90575 19.4913 1.81353 19.4747 1.72409C19.5468 1.40913 19.4652 1.06514 19.2265 0.812803Z",
    fill: "#17A2C6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkArrow);
export default __webpack_public_path__ + "static/media/link-arrow.e9db0f69b0d1d6f4a86089f995f08e34.svg";
export { ForwardRef as ReactComponent };